import React, { useState,useContext, useEffect} from 'react';
import { useFormikContext } from "formik";
import CsplTextBoxField from '../../CsplControls/CsplTextBox/CsplTextBoxField';
import CsplAchField from '../../CsplControls/CsplAch/CsplAchField';
import CsplLabel from '../../CsplControls/CsplLabel/CsplLabel';
import styles from './NominationDetail.module.css';
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { NomineesEnum } from "../../../Enumeration/NomineesEnum";
import { useTranslation } from 'react-i18next';
import { TagEnum } from '../../../Enumeration/TagEnum';
import { TagValueEnum } from '../../../Enumeration/TagValueEnum';
import TagValueResource from '../../Resources/CommonResources/TagValueResource';
import CountryResource from "../../Resources/CommonResources/CountryResource";
import { defaultMobileCountryCode } from "../../../Utils/GlobalValues";

export default function OptionalGaurdianNominee() {
    const { t } = useTranslation("common");
    const [countryId, setCountryId] = useState();
    const applicationContext = useContext(KycApplicationContext);
    const [relationshipId, setRelationshipId] = useState(null);
    const [disable, setDisable] = useState(true);
    const [getTagValue] = TagValueResource();
     //Set enable/disable the control
     // disable if it is in view mode
     let isDisabled = applicationContext.disableForm;
     const { values, setFieldValue } = useFormikContext();
     const {getCountryByMobileCountryCode} = CountryResource();

      //handling country change
  const handleCountryChange =(value) =>{
     setFieldValue(
      "nomineeWidgetDTO.nominee2.guardianDTO.state",
      null
    ); 
    if(value && value.mobileCountryCode && value.mobileCountryCode != ""){
      setFieldValue(
        "nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry",
        value
      );
    }else{
      setFieldValue(
        "nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry",
        null
      );
    }
  }

  const handleRelationship = (newValue) => {
    if (newValue && newValue.name === NomineesEnum.relationship_others) {
      setDisable(false);
      values.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationshipRequired = true;
    } else if (
      newValue &&
      (newValue.name !== NomineesEnum.relationship_others)
    ) {
      setDisable(true);
      values.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationship = "";
      values.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationshipRequired = false;
    }
  };

  //If User Select relationship as 'Others', enable the textbox
  useEffect(() => {
    if (
      values.nomineeWidgetDTO.nominee2 &&
      values.nomineeWidgetDTO.nominee2.guardianDTO &&
      values.nomineeWidgetDTO.nominee2.guardianDTO.relationship
    ) {
      handleRelationship(values.nomineeWidgetDTO.nominee2.guardianDTO.relationship);
    } else if (
      values.nomineeWidgetDTO.nominee2 &&
      values.nomineeWidgetDTO.nominee2.guardianDTO &&
      values.nomineeWidgetDTO.nominee2.guardianDTO.relationship === null
    ) {
      handleRelationship({ name: NomineesEnum.relationship_nan });
    }
  }, [relationshipId, handleRelationship]);


    /*set Default Values */
    useEffect(() => {
      if (
        values &&
        values.nomineeWidgetDTO &&
        values.nomineeWidgetDTO.nominee2 &&
        values.nomineeWidgetDTO.nominee2.guardianDTO
      ) {
        //set default account type
        //setdefaultAccountType();

        //set default mobile country
        setdefaultMobileCountry();
      }
    }, []) 

    //set default Mobile Country
    function setdefaultMobileCountry(){
      if (
        values.nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry == null ||
        values.nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry == undefined
      ) {
        getCountryByMobileCountryCode(defaultMobileCountryCode).then(
          (res) => {
            console.log(res);
            setFieldValue(
              "nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry",
              res
            );
          },
          (error) => {}
        );
      }
    }
  
    /* set default account type */
    function setdefaultAccountType(){
      if (
        values.nomineeWidgetDTO.nominee2.guardianDTO.bankAccountType == null
      ) {
        getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
          (res) => {
            setFieldValue(
              "nomineeWidgetDTO.nominee2.guardianDTO.bankAccountType",
              res
            );
          },
          (error) => {}
        );
      }
    }

    return (
      <>
        {/* Get the Optional Nominee's Guardian Details if user is minor */}
        <div className=" mt-4">
          <div className="row">
            {/* Overall width control */}
            <div className="col-12 mx-auto">
            <p><span className={styles.file_instruction}>{t("nominee.guardianHelpText")}</span></p>
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <p className={styles.gaurdian_header}>
                <CsplLabel label={"nominee.guardianDetail"}></CsplLabel>
              </p>
              </div>

              {/*Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.name"
                  required={true}
                  label={"nominee.name"}
                  disabled={isDisabled}
                  id="optguardianName"
                ></CsplTextBoxField>
              </div>

             {/*RelationShip*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                <CsplAchField
                    lookupName={"guardianRelationship"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.guardianDTO.relationship"
                    required={true}
                    label={"nominee.relationshipWithNominee"}
                    disabled={isDisabled}
                    id="guardianRelationship"
                    getIdValue={setRelationshipId}
                  ></CsplAchField>
                </div>
                <div className="w-100">
                <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee2.guardianDTO.otherRelationship"
                    required={
                      values.nomineeWidgetDTO.nominee2.guardianDTO !== null &&values.nomineeWidgetDTO.nominee2.guardianDTO.otherRelationshipRequired
                    }
                    disabled={isDisabled || disable}
                    label={"nominee.otherRelationship"}
                    id="guardianOtherRelationship"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

              {/*AddressLine1*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.addressLine1"
                  required={false}
                  label={"nominee.addressLine1"}
                  disabled={isDisabled}
                  id="optguardianAddressLine1"
                ></CsplTextBoxField>
              </div>

              {/*AddressLine2*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.addressLine2"
                  required={false}
                  label={"nominee.addressLine2"}
                  disabled={isDisabled}
                  id="optguardianAddressLine2"
                ></CsplTextBoxField>
              </div>

              {/*AddressLine3*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.addressLine3"
                  required={false}
                  label={"nominee.addressLine3"}
                  disabled={isDisabled}
                  id="optguardianAddressLine3"
                ></CsplTextBoxField>
              </div>

              {/* City & Country */}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <div className="d-md-flex justify-content-between">
                  <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                    <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee2.guardianDTO.city"
                      required={true}
                      label={"nominee.city"}
                      disabled={isDisabled}
                      id="optguardianCity"
                    ></CsplTextBoxField>
                  </div>
                  <div className="w-100">
                    <CsplAchField
                      lookupName={"country"}
                      displayColumn="name"
                      idColumn="id"
                      name="nomineeWidgetDTO.nominee2.guardianDTO.country"
                      required={true}
                      label={"nominee.country"}
                      disabled={isDisabled}
                      id="optguardianCountry"
                      getIdValue={setCountryId}
                      onValueChange={handleCountryChange}
                    ></CsplAchField>
                  </div>
                </div>
              </div>

              {/* State & Pincode */}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <div className="d-md-flex justify-content-between">
                  <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                    <CsplAchField
                      lookupName="state"
                      displayColumn="name"
                      idColumn="id"
                      id="optguardianState"
                      label="nominee.state"
                      name="nomineeWidgetDTO.nominee2.guardianDTO.state"
                      required={true}
                      filterValue={countryId}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className="w-100">
                    <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee2.guardianDTO.pincode"
                      required={true}
                      label={"nominee.pincode"}
                      disabled={isDisabled}
                      id="optguardianPincode"
                    ></CsplTextBoxField>
                  </div>
                </div>
              </div>

               {/*Mobile Number & email*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                <CsplAchField
                    lookupName={"mobileCountry"}
                    displayColumn="mobileCountryCode"
                    secondaryColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee2.guardianDTO.mobileCountry"
                    required={true}
                    label={"nominee.mobileCountryCode"}
                    disabled={isDisabled}
                    id="guardian2Mobilecountry"
                  />
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee2.guardianDTO.mobileNo"
                      required={true}
                      label={"nominee.mobileno"}
                      disabled={isDisabled}
                      id="optguardianMobileno"
                    ></CsplTextBoxField>
                </div>
              </div>
            </div>

            {/*email*/}

            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.emailId"
                  required={true}
                  label={"nominee.email"}
                  disabled={isDisabled}
                  id="optguardianEmail"
                ></CsplTextBoxField>
              </div>

              {/*Bank Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.bankName"
                  required={false}
                  label={"nominee.bankName"}
                  disabled={isDisabled}
                  id="optguardianBankName"
                ></CsplTextBoxField>
              </div>

              {/*IFSC code*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.ifscCode"
                  required={false}
                  label={"nominee.ifscCode"}
                  disabled={isDisabled}
                  id="optguardianIfscCode"
                ></CsplTextBoxField>
              </div>

              {/*Branch Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.branchName"
                  required={false}
                  label={"nominee.branchName"}
                  disabled={isDisabled}
                  id="optguardianBranchName"
                ></CsplTextBoxField>
              </div>

              {/*Bank Account Number*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee2.guardianDTO.bankAccountNumber"
                  required={false}
                  label={"nominee.bankAccNo"}
                  disabled={isDisabled}
                  id="optguardianBankAccNo"
                ></CsplTextBoxField>
              </div>

              {/*Bank Account Type*/}

              <div className="col-sm-11 col-12 me-auto">
                <CsplAchField
                      lookupName={"accountTypeExcludeCode"}
                      displayColumn="name"
                      idColumn="id"
                      name="nomineeWidgetDTO.nominee2.guardianDTO.bankAccountType"
                      required={false}
                      label={"nominee.bankAccType"}
                      disabled={isDisabled}
                      id="optguardianBankAccType"
                    ></CsplAchField> 
              </div>
            </div>
          </div>
        </div>
      </>
    );
}